module.exports = __webpack_public_path__ + "static/media/Aleron_IT.7328ecf2.png";